import {Component, OnInit} from '@angular/core';
import {ExamesTesteSoproService} from "./exames-teste-sopro.service";
import {ExamesTesteSoproModel} from "./exames-teste-sopro.model";
import {Global} from "../../global";
import {Components} from "../../shared/components/components";
import {TranslateService} from '@ngx-translate/core';
import {Router} from "@angular/router";
import {Funcoes} from "../../funcoes";
import {LoginService} from "../../login/login.service";

declare var swal: any;

@Component({
  selector: 'app-exames-teste-sopro',
  templateUrl: './exames-teste-sopro.component.html'
})
export class ExamesTesteSoproComponent extends Components implements OnInit {

  testes: ExamesTesteSoproModel[] = [];
  privilegioUsuario = {"editar": false, "consultar": false};
  selecionarTodos: boolean = false;
  selecionados: { [key: string]: boolean } = {};
  carregandoAcoesEmMassa: boolean = false;
  processandoItem: { [key: string]: boolean } = {};

  constructor(
    private examesTesteSoproService: ExamesTesteSoproService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    this.loginService.getUserInfo().subscribe(data => {
      for(let i in data.privilegios){
        if(data.privilegios[i].acao && data.privilegios[i].acao[0] && (data.privilegios[i].acao[0].url == 'exames' || data.privilegios[i].id_acao == '33')){
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
    });
  }

  ngOnInit() {
    this.carregandoTabela = true;
    this.examesTesteSoproService.getPaginacao(1, this.itensPorPagina)
      .subscribe(data => {
        this.testes = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;

        if (this.global.debug) {
          console.log(this.testes);
        }
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });
  }

  delete(teste) {
    let testes = this.testes;
    let examesTesteSoproService = this.examesTesteSoproService;
    let navioTxt = (teste.navio ? teste.navio.nome : teste.navio_nome) || ('ID ' + teste.id);

    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaDeletarTesteSopro') + ': ' + navioTxt,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      () => {
        if(this.global.debug == true){
          console.log(testes);
        }

        let index = testes.indexOf(teste);
        testes.splice(index, 1);

        examesTesteSoproService.apagar(teste.id)
          .subscribe(res => {
              this.testes = testes;
            },
            err => {
              testes.splice(index, 0, teste);
              this.testes = testes;
              this.func.showErro(err.json());
            });
      });
  }

  abrirPdf(teste, lang?: string) {
    let url = this.examesTesteSoproService.getPdfUrl(teste.id, lang || teste.idioma);
    window.open(url, '_blank');
  }

  getPage(pagina){
    this.paginaAtual = pagina;
    this.carregandoTabela = true;
    this.selecionados = {};
    this.selecionarTodos = false;
    this.examesTesteSoproService.getPaginacao(pagina, this.itensPorPagina)
      .subscribe(data => {
        this.testes = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });
  }

  marcarTodos(event) {
    this.selecionarTodos = event.target.checked;
    this.testes.forEach(teste => {
      this.selecionados[teste.id] = this.selecionarTodos;
    });
  }

  marcarItem(teste, event) {
    this.selecionados[teste.id] = event.target.checked;

    if (!event.target.checked) {
      this.selecionarTodos = false;
    } else {
      let todosMarcados = true;
      for (let t of this.testes) {
        if (!this.selecionados[t.id]) {
          todosMarcados = false;
          break;
        }
      }
      this.selecionarTodos = todosMarcados;
    }
  }

  getSelecionadosIds(): string[] {
    let ids = [];
    for (let id in this.selecionados) {
      if (this.selecionados[id]) {
        ids.push(id);
      }
    }
    return ids;
  }

  alteraStatus(idTeste, idStatus, notifica = true) {
    let self = this;
    swal({
      title: this.func.traduzir('front.voceTemCerteza'),
      text: this.func.traduzir('front.desejaAlterarStatus'),
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: this.func.traduzir('front.confirmar'),
      cancelButtonText: this.func.traduzir('front.cancelar'),
      closeOnConfirm: true,
    }, function () {
      self.processandoItem[idTeste] = true;
      self.examesTesteSoproService.setStatus(idTeste, idStatus, notifica)
        .subscribe(res => {
          delete self.processandoItem[idTeste];
          swal(self.func.traduzir('front.sucesso'), self.func.traduzir('front.statusAlterado'), "success");
          self.getPage(self.paginaAtual);
        }, error => {
          delete self.processandoItem[idTeste];
          swal(self.func.traduzir('front.erro'), self.func.traduzir('front.statusNaoAlterado'), "error");
          self.func.showErro(error.json());
        });
    });
  }

  executarAcaoEmMassa(acao: string, extraParam: any = null) {
    let selecionadosIds = this.getSelecionadosIds();
    if (selecionadosIds.length == 0) {
      swal(this.func.traduzir('front.erro'), this.func.traduzir('front.selecionePeloMenosUmItem'), "error");
      return;
    }

    let self = this;
    swal({
      title: this.func.traduzir('front.voceTemCerteza'),
      text: this.func.traduzir('front.desejaExecutarAcaoMassa'),
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: this.func.traduzir('front.confirmar'),
      cancelButtonText: this.func.traduzir('front.cancelar'),
      closeOnConfirm: true
    }, function () {
      self.carregandoAcoesEmMassa = true;
      let total = selecionadosIds.length;
      let concluidos = 0;

      selecionadosIds.forEach(id => {
        self.processandoItem[id] = true;

        let obs;
        if (acao == 'deletar') obs = self.examesTesteSoproService.apagar(id);
        if (acao == 'notificar') obs = self.examesTesteSoproService.enviarTesteParaCliente(id);
        if (acao == 'status') obs = self.examesTesteSoproService.setStatus(id, extraParam.id_status, extraParam.notifica);

        obs.subscribe(
          res => {
            delete self.processandoItem[id];
            concluidos++;
            if (concluidos == total) {
              self.carregandoAcoesEmMassa = false;
              swal(self.func.traduzir('front.sucesso'), self.func.traduzir('front.acaoConcluida'), "success");
              self.getPage(self.paginaAtual);
              self.selecionados = {};
              self.selecionarTodos = false;
            }
          },
          err => {
            delete self.processandoItem[id];
            concluidos++;
            self.func.showErro(err.json());
            if (concluidos == total) {
              self.carregandoAcoesEmMassa = false;
              self.getPage(self.paginaAtual);
            }
          }
        );
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/exames/teste-sopro/exames-teste-sopro.component.ts